import ReactDOM from 'react-dom/client'
import { HeroUIProvider } from '@heroui/react'

import './main.css'

import { App } from './App'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <HeroUIProvider>
    <App />
  </HeroUIProvider>,
)
